import axios from "axios";

let loaded = null;

const addScript = (src) => { const s = document.createElement("script"); s.async = true; s.src = src; document.head.appendChild(s); };

function initMeta(id) {
  if (window.fbq) return;
  const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
  fbq.push = fbq; fbq.loaded = true; fbq.version = "2.0"; fbq.queue = [];
  window.fbq = window._fbq = fbq;
  addScript("https://connect.facebook.net/en_US/fbevents.js");
  window.fbq("init", id); window.fbq("track", "PageView");
}

function initGoogle(id) {
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  addScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`);
  window.gtag("js", new Date()); window.gtag("config", id);
}

export function loadTracking() {
  captureAttribution();
  if (!loaded) loaded = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/tracking`).then(({ data }) => {
    if (data.meta_pixel_id) initMeta(data.meta_pixel_id);
    if (data.google_tag_id) initGoogle(data.google_tag_id);
    return data;
  }).catch(() => ({}));
  return loaded;
}

const EVENTS = { lead: ["Lead", "generate_lead"], signup: ["CompleteRegistration", "sign_up"], trial_click: ["InitiateCheckout", "begin_trial_click"] };

export async function trackEvent(name) {
  const cfg = await loadTracking(); const [meta, google] = EVENTS[name];
  if (window.fbq && cfg.meta_pixel_id) window.fbq("track", meta);
  if (window.gtag && cfg.google_tag_id) {
    window.gtag("event", google);
    if (name === "signup" && cfg.google_ads_conversion) window.gtag("event", "conversion", { send_to: cfg.google_ads_conversion });
  }
}

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getAttribution() {
  try { return JSON.parse(localStorage.getItem("feemitra_attr") || "{}"); } catch { return {}; }
}

export function captureAttribution() {
  const p = new URLSearchParams(window.location.search);
  const src = p.get("utm_source") || (p.get("ref") ? "referral" : "");
  if (src && !localStorage.getItem("feemitra_attr")) localStorage.setItem("feemitra_attr", JSON.stringify({ source: src.toLowerCase(), campaign: p.get("utm_campaign") || "" }));
  if (sessionStorage.getItem("feemitra_visit")) return;
  sessionStorage.setItem("feemitra_visit", "1");
  let vid = localStorage.getItem("feemitra_vid");
  if (!vid) { vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("feemitra_vid", vid); }
  const a = getAttribution();
  axios.post(`${API_BASE}/public/visit`, { vid, source: src || a.source || "", campaign: p.get("utm_campaign") || a.campaign || "", path: window.location.pathname }).catch(() => {});
}

export function demoEvent(event) {
  const k = `feemitra_de_${event}`;
  if (sessionStorage.getItem(k)) return;
  sessionStorage.setItem(k, "1");
  let vid = localStorage.getItem("feemitra_vid");
  if (!vid) { vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("feemitra_vid", vid); }
  axios.post(`${API_BASE}/public/demo-event`, { vid, event }).catch(() => {});
}

export function markDemoSeen() {
  localStorage.setItem("feemitra_demo", "1");
  if (sessionStorage.getItem("feemitra_demo_view")) return;
  sessionStorage.setItem("feemitra_demo_view", "1");
  let vid = localStorage.getItem("feemitra_vid");
  if (!vid) { vid = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`); localStorage.setItem("feemitra_vid", vid); }
  axios.post(`${API_BASE}/public/demo-view`, { vid }).catch(() => {});
}
